module.exports = __webpack_public_path__ + "static/media/grid5.86a32681.jpg";